/** Voz da home — curta, humana. Sem “vitrine”. */

export const HOME_HERO = {
  title: 'Cuidando de quem cuida.',
  lead: 'Cuidar de si é o que permite continuar perto de quem precisa de você.',
  cta: 'Ver as pausas',
} as const;

export const HOME_INTRO = {
  id: 'marca',
  eyebrow: 'O eixo',
  title: 'Quem cuida de você?',
  body: 'Um momento de cuidado não é mimo: é o que sustenta presença e equilíbrio.',
  pontos: [
    { n: '01', t: 'Presença', d: 'Chegar mais inteiro a quem importa.' },
    { n: '02', t: 'Ritmo', d: 'Pausas que cabem no dia.' },
    { n: '03', t: 'Continuidade', d: 'Cuidar de si para continuar cuidando.' },
  ],
} as const;

export const HOME_PRODUTOS = {
  id: 'compradores',
  eyebrow: 'Na rotina',
  title: 'Pequenas pausas que cabem no dia.',
  items: [
    {
      id: 'car-relax-shoulder',
      beneficio: 'Conforto para ombros e costas depois de horas sentada.',
    },
    {
      id: 'cadeira-shiatsu-still',
      beneficio: 'Um lugar para desacelerar quando o corpo pede.',
    },
    {
      id: 'massageador-pes-shiatsu-pro',
      beneficio: 'Alívio para os pés no fim do dia.',
    },
  ],
  verItem: 'Conhecer esta pausa',
  verTodos: 'Ver outras pausas',
} as const;

export const HOME_EXPERIENCIA = {
  id: 'organizacoes',
  eyebrow: 'No trabalho',
  title: 'O mesmo cuidado, também nas instituições.',
  fotos: [
    {
      src: '/images/home/experiencia-instituicao.jpg',
      alt: 'Pausa de bem-estar em contexto institucional',
      kicker: 'Instituições',
      caption: 'Um intervalo para quem está em serviço.',
    },
    {
      src: '/images/home/experiencia-pes.jpg',
      alt: 'Pausa compartilhada de bem-estar',
      kicker: 'Rotina',
      caption: 'Cuidado no meio do expediente.',
    },
  ],
  circuito: 'Órgãos públicos',
  institucional: 'lunins.org',
} as const;

export const HOME_COMO = {
  id: 'comprar',
  eyebrow: 'Como seguir',
  title: 'Escolha com calma. A gente acompanha.',
  passos: [
    { n: '01', t: 'Encontre', d: 'O que faz sentido para o seu ritmo.' },
    { n: '02', t: 'Converse', d: 'A equipe confirma com você.' },
    { n: '03', t: 'Combine', d: 'Pagamento só com orientação Lunins.' },
  ],
  nota: 'Prazo e frete conforme região e campanha.',
} as const;

export const HOME_PROVA = {
  id: 'depoimentos',
  quote: 'Cuidar de si também é continuar cuidando de quem está ao redor.',
  attribution: 'Lunins',
  tutorialId: 'tutoriais',
  tutorial: '@luninsbr',
} as const;

export const HOME_CTA = {
  title: 'Quando você quiser um momento só seu.',
  button: 'Ver as pausas',
} as const;
